import { render, staticRenderFns } from "./SocialPosts.vue?vue&type=template&id=e7ef2fc0&scoped=true"
import script from "./SocialPosts.vue?vue&type=script&lang=js"
export * from "./SocialPosts.vue?vue&type=script&lang=js"
import style0 from "./SocialPosts.vue?vue&type=style&index=0&id=e7ef2fc0&prod&scoped=true&lang=css"
import style1 from "./SocialPosts.vue?vue&type=style&index=1&id=e7ef2fc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ef2fc0",
  null
  
)

export default component.exports